<template v-if="dialogVisible">
	<el-dialog :title="$t('avatar.setAvatar')" :visible.sync="dialogVisible" width="880px" show-close :destroy-on-close="true">
		<el-main v-loading="loading">
			<div class="avatar-box">
				<!-- 剪裁区域 -->
				<div class="corp">
					<vueCropper
						ref="cropper"
						:img="option.img"
						:outputSize="option.size"
						:outputType="option.outputType"
						@realTime="realTime"
						:full="false"
						:autoCrop="true"
						:fixedNumber="option.fixedNumber"
						:fixed="option.fixed"
						:centerBox="option.centerBox"
					></vueCropper>
				</div>
				<!-- 上传区域 -->
				<div class="upload">
					<h3 class="previews-title" v-if="option.img">{{ $t("avatar.preview") }}</h3>
					<div class="show-preview" :style="{ width: previews.w + 'px', height: previews.h + 'px', overflow: 'hidden', margin: '5px' }">
						<div class="show-preview-img">
							<img class="tailor-img" :src="option.img" :style="previews.img" />
						</div>
					</div>
				</div>
			</div>
			<div class="footer">
				<div class="corp-btn">
					<el-upload action="" accept="image/*" :before-upload="beforeUpload" class="upload-input">
						<el-button size="small" type="primary">{{ $t("avatar.changePicture") }}</el-button>
					</el-upload>
					<el-button size="small" type="primary" @click="changeScale(1)">
						<i class="btn-icon el-icon-zoom-in"></i>{{ $t("avatar.enlarge") }}
					</el-button>
					<el-button size="small" type="primary" @click="changeScale(-1)">
						<i class="btn-icon el-icon-zoom-out"></i>{{ $t("avatar.zoomOut") }}
					</el-button>
					<el-button size="small" type="primary" @click="rotate('left')">
						<i class="btn-icon el-icon-refresh-left"></i>{{ $t("avatar.rotateLeft") }}
					</el-button>
					<el-button size="small" type="primary" @click="rotate('right')">
						<i class="btn-icon el-icon-refresh-right"></i>{{ $t("avatar.rotateRight") }}
					</el-button>
				</div>
				<div class="upload-btn">
					<el-button size="small" :disabled="uploadBtnDisable" type="primary" @click="uploadAvatar">{{ $t("avatar.upload") }}</el-button>
				</div>
			</div>
		</el-main>
	</el-dialog>
</template>
<script>
import { VueCropper } from "vue-cropper";
import { getBase64Avatar } from "@/services/api/api";
var Buffer = require("buffer/").Buffer;
import { getSignature, updateAvatar } from "@/services/api-v2/api-v2";
import { upload } from "@/services/oss/oss";

export default {
	name: "avatar",

	components: {
		VueCropper,
	},

	data() {
		return {
			dialogVisible: false,
			uploadBtnDisable: true,
			imgScale: 0,
			previews: "",
			option: {
				size: 1,
				outputType: "png",
				img: "",
				fixedNumber: [1, 1],
				fixed: true,
				centerBox: true,
			},
			loading: false,
		};
	},

	methods: {
		async showDailog() {
			this.dialogVisible = true;
			this.loading = true;
			try {
				const { data } = await getBase64Avatar(this.$store.state.user.avatar);
				this.option.img = "data:image/png;base64," + data;
			} catch (err) {
				this.$message({ message: this.$t("avatar.errorGetAvatar"), type: "error" });
			} finally {
				this.loading = false;
			}
		},

		beforeUpload(file) {
			const isLt2M = file.size / 1024 / 1024 < 2;
			if (!isLt2M) {
				this.$message.error(this.$t("avatar.sizeCannotExceed"));
				return false;
			}

			const _this = this;
			const reader = new FileReader();
			reader.readAsDataURL(file);
			reader.onload = function () {
				_this.$refs.cropper.startCrop();
				_this.option.img = reader.result;
			};

			return false;
		},

		realTime(data) {
			this.previews = data;

			if (this.option.img != "") {
				this.uploadBtnDisable = false;
			}
		},

		async upload() {
			this.$refs.cropper.getCropData((data) => {
				// 去掉 "data:image/png;base64,"
				data = data.split(",");
				const formData = { avatar: data[1] };

				this.avatarUploadRequest(formData.avatar);
			});
		},

		uploadAvatar() {
			if (this.option.img == "") {
				this.$message({ message: this.$t("avatar.selectPicture"), type: "error" });
				return false;
			}
			this.$refs.cropper.stopCrop();
			this.upload();
		},

		changeScale(value) {
			this.$refs.cropper.changeScale(value);
		},

		rotate(direction) {
			direction === "left" ? this.$refs.cropper.rotateLeft() : this.$refs.cropper.rotateRight();
		},

		async avatarUploadRequest(imageFile) {
			try {
				const imageBuffer = await Buffer.from(imageFile, "base64");

				const {
					data: { filename, path, sign_url },
				} = await getSignature("avatar");

				// 上传头像到oss
				await upload(sign_url, imageBuffer, "image/jpeg");

				// 更新 User avatar（响应含后端签名的 avatar_url）
				const response = await updateAvatar(filename);

				this.uploadBtnDisable = true;

				this.$store.dispatch("upateUserAvatar", { avatar: response.data.avatar, avatarUrl: response.data.avatar_url || null });

				this.$message({ message: this.$t("avatar.setupSuccessful"), type: "success" });
			} catch (e) {
				this.$message({ message: this.$t("avatar.uploadFailed"), type: "error" });
			}
		},
	},

	watch: {
		// 每次关闭弹框清除图片
		dialogVisible: function (value) {
			if (value === false) {
				this.option.img = "";
			}
		},
	},
};
</script>

<style lang="less" scoped>
.previews-title {
	max-width: 300px !important;
	margin-top: 0px;
}
/**重写插件样式 */
.vue-cropper {
	background: none !important;
	border: 1px solid #c0c4cc;
}
.not-img {
	width: 100%;
	height: 100%;
	background: none !important;
	border: 1px solid #c0c4cc;
	line-height: 360px;
	text-align: center;
}
.avatar-box {
	height: 460px;
	.corp {
		float: left;
		height: 350px;
		width: 50%;
	}
	.upload {
		float: left;
		margin-left: 40px;
		h3 {
			text-align: center;
		}
	}
}
.footer {
	border-top: 1px solid #ccc;
	padding: 15px 0 0 0;
	.upload-input {
		margin: 0 15px 0 0;
		float: left;
	}
	.corp-btn {
		float: left;
		.btn-icon {
			font-size: 12px;
			margin: 0 5px 0 0;
		}
	}
	.upload-btn {
		float: right;
	}
	&::after {
		content: "";
		display: block;
		clear: both;
	}
}

.tailor-img {
	width: 300px !important;
	height: 300px !important;
}
</style>
